<template>
  <div
    class="wrapper"
    :style="{ borderColor: `rgba(96,71,18,0.4)` }"
    @contextmenu.prevent="blockRightButton"
  >
    <comp-header
      show-haohuo
      @close="closeReport"
      @feedback="feedbackReport"
    />
    <user-info
      @showPay="showPayFn"
      @showChangeUserInfoPop="showChangeUserInfoPop"
      @toRank="report({ click: 53 })"
    />
    <div
      class="wrap_scroll"
      :style="{ height: wrapHeight }"
    >
      <slot />
    </div>

    <!-- 修改用户信息弹窗 -->
    <ChangeUserInfoPop
      v-if="isChangeUserInfoPop"
      v-model="isChangeUserInfoPop"
    />
  </div>
</template>
<script>
import UserInfo from '@/components/userInfo/UserInfo.vue'
import CompHeader from '@/layout/Header.vue'
import { mapGetters } from 'vuex'
import client from '@/client/'
import { STAY_PAGE_NUM, LOCALSTORAGE_POSITION_KEY, LOCALSTORAGE_PAY_HEIGHT_KEY } from '@/config/dataMap'
import ChangeUserInfoPop from '@/components/userInfo/ChangeUserInfoPop'
import { scrollTo } from '@/utils/scroll'

export default {
  name: 'HomeHeader',
  components: {
    UserInfo,
    CompHeader,
    ChangeUserInfoPop
  },
  data () {
    return {
      showPay: false,
      isModalExaminationPay: false,
      modalTop: 0,
      modalHeight: 0,
      isNoScroll: false,
      startTime: 0,
      loopBindeResultTimer: null,
      loopPayResultTimer: null,
      loopLatestOrderTimer: null,
      haohuoModal: false,
      wrapHeight: '570px',
      isChangeUserInfoPop: false
    }
  },
  computed: {
    ...mapGetters([
      'isMember',
      'loginStatus',
      'isTourist',
      'openId',
      'token',
      'privilege',
      'touristLogout',
      'userInfo'
    ]),
    memberShow () {
      return !!(this.isMember && this.loginStatus)
    },
    examinationModalShow () {
      return (
        this.loginStatus &&
        this.privilege &&
        (this.privilege.privilege_status === 1 ||
          this.privilege.privilege_status === 2)
      )
    }
  },
  watch: {
  },
  /* eslint-disable-next-line */
  async mounted () {
    this.$nextTick(() => {
      this.wrapHeight = this.getWrapHeight()
    })
  },
  methods: {
    // 屏蔽右键
    blockRightButton () {
      return false
    },
    closeReport () {
      client.home.REPORT.reportCenterStayTimeKfmt({
        show_page: STAY_PAGE_NUM[this.$route.name],
        user_login: this.loginStatus ? 1 : 2
      })
      this.report({ click: 7 })
      // 清除滚动条位置
      this.clearScrollPosition()
    },
    feedbackReport () {
      let id
      if (this.loginStatus) {
        if (this.isMember) {
          id = 29
        } else {
          id = 36
        }
      } else {
        id = 35
      }

      this.report({ click: id })
    },
    showPayFn () {
      if (this.$route.name === 'Home') {
        const _parent = document.querySelector('.wrap_scroll')
        _parent.scrollTop = 0
      }
      this.$router.push({ name: 'Home' })
    },
    clearScrollPosition () {
      localStorage.removeItem(LOCALSTORAGE_POSITION_KEY)
      localStorage.removeItem(LOCALSTORAGE_PAY_HEIGHT_KEY)
    },
    report ({
      click = 0,
      hover = 0,
      sub_mode = (this.$refs.payModule &&
        this.$refs.payModule.sub_mode) ||
        0
    }) {
      client.home.REPORT.reportHomeOperate({
        main_click: click,
        main_hover: hover,
        sub_mode,
        user_login: this.loginStatus ? 1 : 2
      })
    },
    scrollToPay () {
      this.$router.push('/')
      const className = 'new-pay'
      const _dom = document.querySelector(`.${className}`)
      if (!_dom) {
        return
      }
      const scrollTop = _dom.offsetTop
      const _parent = document.querySelector('.wrap_scroll')
      scrollTo(scrollTop, 0, _parent)
    },
    getWrapHeight () {
      if (this.integralSwtich) {
        return '570px'
      }
      return '620px'
    },
    showChangeUserInfoPop () {
      this.isChangeUserInfoPop = true
    }
  }
}
</script>
<style lang="scss">
::selection {
  background: transparent;
}
.wrapper {
  position: relative;
  width: 702px;
  height: 742px;
  margin: 0 auto;
  border: 1px solid rgba(21, 161, 225, 0.4);
  box-sizing: border-box;
}

.noScroll {
  overflow-y: hidden;
}
.wrap_scroll {
  position: relative;
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
}
</style>
